import * as React from 'react';
import { CommandBarButton, Stack, IStackStyles, IContextualMenuProps, IconButton } from 'office-ui-fabric-react';
import { UserName } from '../../constants/GlobalConstants';
import { getStorage, clearStorage } from '../../lib/LocalStorageService';
import { IHeaderProps, IHeaderState } from '../../interfaces/IHeader';
import history from '../../lib/history';

const stackStyles: Partial<IStackStyles> = { root: {} };

const menuProps: IContextualMenuProps = {
  items: [
    {
      key: 'userName',
      text: getStorage(UserName)
    },
    {
      key: 'signOut',
      text: 'Uitloggen',
      onClick: () => { _signOut() }
    }
  ]
};

async function _signOut() {
  // const msalInstance = new Msal.UserAgentApplication({
  //   auth: {
  //     clientId: AppId
  //   }
  // });
  // msalInstance.logout();
  clearStorage();
  history.push("/");

}
export default class Header extends React.Component<IHeaderProps, IHeaderState> {
  constructor(props: IHeaderProps) {
    super(props);

    this.state = {
    }
  }

  getShortName(fullName: string): string {
    return fullName.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
  }

  public render() {
    return (
      <div className="top-bar">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <IconButton iconProps={{ iconName: 'Back' }} title="Terug" ariaLabel="Terug" className="back-icon"
                style={{ visibility: this.props.isBackVisible ? "visible" : "hidden" }} onClick={this.props._onBack} />
            </div>
            <div className="col-auto">
              <span><b>Meerwerkbon App</b></span>
            </div>
            <div className="col-auto" >
              <Stack horizontal>
                <CommandBarButton styles={stackStyles}
                  text={this.getShortName(getStorage(UserName))}
                  menuProps={menuProps}
                  className="userLabel"
                />
              </Stack>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
